import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-primary-button',
    templateUrl: 'primary-button.component.html',
    styleUrls: ['primary-button.component.scss']
})
export class PrimaryButtonComponent {
    @Input()
    disabled = false;
    @Input()
    isLoading = false;

    showLoader() {
        this.isLoading = true;
    }

    hideLoader() {
        this.isLoading = false;
    }
}